import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../Components/NavBar/NavBar";
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Form,
} from 'react-bootstrap';
import Footer from "../Components/Footer/Footer";
import Select from 'react-select';
import { Link } from "react-router-dom";
import axios from 'axios';
import TestimonialSection from "../Components/Shared/Testimonials";
// import { toast, ToastContainer } from 'react-toastify';

const ITEMS_PER_PAGE = 12;

const categoryOptions = [
    { value: 'Smartphones', label: 'Smartphones' },
    { value: 'Laptops', label: 'Laptops' },
    { value: 'Accessories', label: 'Accessories' },
    { value: 'all', label: 'All' },
];

const priceOptions = [
    { value: 'low', label: 'Price: Low to High' },
    { value: 'high', label: 'Price: High to Low' },
];

const Product = () => {
    const defaultCategory = categoryOptions.find(opt => opt.value === 'all') || categoryOptions[0];
    const [selectedCategory, setSelectedCategory] = useState(defaultCategory);
    const [priceOrder, setPriceOrder] = useState(priceOptions[0]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);

    const customerReviews = [
        {
            name: "Rahul Sharma",
            rating: 5,
            text: "Got my MacBook on 0% EMI! Delivery was super fast 🚀",
            avatar: "👨"
        },
        {
            name: "Priya Patel",
            rating: 5,
            text: "Gaming laptop under ₹60k with 24-month EMI. Perfect deal!",
            avatar: "👩"
        },
        {
            name: "Amit Kumar",
            rating: 4,
            text: "Student discount + no processing fee. Highly recommend!",
            avatar: "🧑"
        },
        {
            name: "Sneha R.",
            rating: 5,
            text: "Upgraded to i7 laptop. EMI made it affordable 💯",
            avatar: "👩"
        }
    ];

    useEffect(() => {
        async function fetchProducts() {
            setLoading(true);
            const res = await axios.get("https://www.azzenterprises.com/api/products");
            setProducts(res.data);
            setLoading(false);
        }
        fetchProducts();
    }, []);

    const filtered = useMemo(() => {
        let result = [...products];

        if (selectedCategory && selectedCategory.value !== 'all') {
            result = result.filter(p => p.category === selectedCategory.value);
        }

        if (searchTerm.trim()) {
            result = result.filter(p =>
                p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (priceOrder) {
            result.sort((a, b) =>
                priceOrder.value === 'low' ? a.sales_price - b.sales_price : b.sales_price - a.sales_price
            );
        }

        return result;
    }, [products, selectedCategory, priceOrder, searchTerm]);

    const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginated = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const goToPage = (n) => {
        if (n >= 1 && n <= totalPages) setCurrentPage(n);
    };
    const [randomReview, setRandomReview] = useState(null);

    useEffect(() => {
        // Pick random review on mount
        const randomIndex = Math.floor(Math.random() * customerReviews.length);
        setRandomReview(customerReviews[randomIndex]);
    }, []);

    return (
        <div>
            <Helmet>
                <title>Products</title>
            </Helmet>
            {/* <ToastContainer position="top-right" autoClose={5000} /> */}
            <NavBar />
            <main>
                <section className="bg-light py-md-5">
                    <Container>
                        <div className="bg-light py-4 text-center px-3 mb-3">
                            <h2 className="h3 fw-bold mb-3">
                                <span className="text-primary">EMI-Friendly</span> Laptops, Made Easy
                            </h2>
                            <p className="text-muted mb-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
                                Explore powerful laptops with flexible EMI options and exclusive pricing.
                            </p>
                            <Button as={Link} to="/sign-up" variant="primary" className="rounded-pill fw-semibold px-4 py-2">
                                Register <i className="bi bi-arrow-right ms-2"></i>
                            </Button>
                        </div>

                        <div className="filter-pills mb-4">
                            <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center" style={{ maxWidth: '900px', margin: '0 auto' }}>
                                <div className="filter-pill-compact position-relative" style={{ minWidth: '200px', flex: '0 0 auto' }}>
                                    <i className="bi bi-laptop text-primary me-1 fs-6"></i>
                                    <Select
                                        options={categoryOptions}
                                        value={selectedCategory}
                                        onChange={(opt) => {
                                            setSelectedCategory(opt);
                                            setCurrentPage(1);
                                        }}
                                        className="compact-select w-100"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            control: (base) => ({
                                                ...base,
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                minHeight: '36px',
                                                fontSize: '14px',
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                marginTop: '4px',
                                                borderRadius: '12px',
                                                minWidth: '150px',
                                                width: '150px',
                                                left: 0,
                                                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                                border: '1px solid #e9ecef'
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: '2px 8px',
                                                color: '#6c757d',
                                                svg: { transform: 'scale(0.6)' }
                                            }),
                                            indicatorSeparator: () => ({ display: 'none' }),
                                            option: (base, state) => ({
                                                ...base,
                                                padding: '10px 16px',
                                                fontSize: '14px',
                                                background: state.isSelected
                                                    ? 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)'
                                                    : state.isFocused
                                                        ? '#f8f9ff'
                                                        : '#fff',
                                                color: state.isSelected ? '#fff' : '#212529'
                                            })
                                        }}
                                    />
                                </div>

                                <div className="filter-pill-compact position-relative" style={{ minWidth: '140px', flex: '0 0 auto' }}>
                                    <i className="bi bi-tag-fill text-success me-1 fs-6"></i>
                                    <Select
                                        options={priceOptions}
                                        value={priceOrder}
                                        onChange={(opt) => {
                                            setPriceOrder(opt);
                                            setCurrentPage(1);
                                        }}
                                        className="compact-select w-100"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            control: (base) => ({
                                                ...base,
                                                background: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                minHeight: '36px',
                                                fontSize: '14px',
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                marginTop: '4px',
                                                borderRadius: '12px',
                                                minWidth: '180px',
                                                width: '180px',
                                                left: 0,
                                                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                                border: '1px solid #e9ecef'
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: '2px 8px',
                                                color: '#6c757d',
                                                svg: { transform: 'scale(0.6)' }
                                            }),
                                            indicatorSeparator: () => ({ display: 'none' }),
                                            option: (base, state) => ({
                                                ...base,
                                                padding: '10px 16px',
                                                fontSize: '14px',
                                                background: state.isSelected
                                                    ? 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)'
                                                    : state.isFocused
                                                        ? '#f8f9ff'
                                                        : '#fff',
                                                color: state.isSelected ? '#fff' : '#212529'
                                            })
                                        }}
                                    />
                                </div>

                                <div className="filter-pill-compact flex-grow-1 position-relative" style={{ minWidth: '200px', maxWidth: '350px', flex: '1 1 200px' }}>
                                    <i className="bi bi-search-heart text-warning fs-6 position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                                    <Form.Control
                                        type="search"
                                        placeholder="Search products"
                                        className="shadow-none ps-4 pe-4"
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            outline: 'none',
                                            height: '36px',
                                            fontSize: '14px',
                                            color: '#212529'
                                        }}
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <Row className="g-2 g-sm-3 g-lg-3 pt-2">
                            {loading ? (
                                <Col xs={12}>
                                    <div className="d-flex justify-content-center align-items-center py-5">
                                        <div className="spinner-border text-primary" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </Col>
                            ) : paginated.length > 0 ? (
                                paginated.map(product => {
                                    const discount = product.price && product.sales_price
                                        ? Math.round((1 - product.sales_price / product.price) * 100)
                                        : 0;

                                    return (
                                        <Col key={product.product_id} xs={6} sm={6} md={3} lg={3} xl={2} xxl={2}>
                                            <Card className="h-100 border-0 shadow-sm rounded-3 overflow-hidden hover-card-compact transition-all position-relative">
                                                <div className="position-relative bg-light p-2" style={{ height: '160px' }}>
                                                    <Card.Img
                                                        src={product.product_img}
                                                        alt={product.product_name}
                                                        style={{
                                                            objectFit: "contain",
                                                            height: "100%",
                                                            width: "100%",
                                                            objectPosition: "center"
                                                        }}
                                                    />
                                                    {discount > 0 && (
                                                        <span className="position-absolute top-0 end-0 m-1 px-2 py-1 bg-danger text-white fw-bold rounded-pill fs-2xs"
                                                            style={{ fontSize: '0.65rem' }}
                                                        >
                                                            {discount}% OFF
                                                        </span>
                                                    )}
                                                </div>

                                                <Card.Body className="p-2 d-flex flex-column">
                                                    <Card.Title className="fw-semibold mb-1 text-dark line-clamp-2"
                                                        style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
                                                        {product.product_name}
                                                    </Card.Title>

                                                    <div className="text-muted mb-2 line-clamp-1 fs-2xs"
                                                        style={{ fontSize: '0.7rem', lineHeight: '1.2' }}>
                                                        {[
                                                            product.capacity,
                                                            product.color,
                                                            product.display?.split(' ')[0],
                                                            product.size_and_weight
                                                        ].filter(Boolean).slice(0, 3).join(" • ") || '—'}
                                                    </div>

                                                    <div className="mt-auto">
                                                        <div className="mb-1">
                                                            {product.price && product.sales_price && parseFloat(product.price) > parseFloat(product.sales_price) && (
                                                                <span className="text-muted text-decoration-line-through me-1 fs-2xs" style={{ fontSize: '0.7rem' }}>
                                                                    ₹{parseFloat(product.price).toLocaleString('en-IN')}
                                                                </span>
                                                            )}
                                                            <span className="text-primary fw-bold fs-1" style={{ fontSize: '1rem' }}>
                                                                ₹{parseFloat(product.sales_price || 0).toLocaleString('en-IN')}
                                                            </span>
                                                        </div>

                                                        <div className="fs-2xs fw-semibold d-flex align-items-center mt-1"
                                                            style={{ fontSize: '0.7rem' }}>
                                                            {product.status === 'Inactive' ? (
                                                                <span className="text-danger">
                                                                    <i className="bi bi-x-circle me-1"></i> Out of Stock
                                                                </span>
                                                            ) : (
                                                                <span className="text-success">
                                                                    <i className="bi bi-check-circle me-1"></i> In Stock
                                                                </span>
                                                            )}
                                                        </div>

                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    );
                                })
                            ) : (
                                <Col xs={12}>
                                    <div className="text-center py-5">
                                        <i className="bi bi-inbox display-4 text-muted mb-3"></i>
                                        <h6 className="text-muted mb-1">No products found</h6>
                                        <p className="text-muted small mb-0">Try adjusting your filters</p>
                                    </div>
                                </Col>
                            )}
                        </Row>

                        {totalPages > 1 && (
                            <div className="d-flex justify-content-center mt-5">
                                <ul className="pagination-custom list-unstyled d-flex gap-2">
                                    <li>
                                        <Button
                                            variant="outline-secondary"
                                            className="rounded-pill px-3 py-1"
                                            disabled={currentPage === 1}
                                            onClick={() => goToPage(currentPage - 1)}
                                        >
                                            &laquo;
                                        </Button>
                                    </li>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <li key={i + 1}>
                                            <Button
                                                variant={currentPage === i + 1 ? 'primary' : 'outline-primary'}
                                                className={`rounded-pill px-3 py-1 fw-semibold ${currentPage === i + 1 ? 'text-white' : ''}`}
                                                onClick={() => goToPage(i + 1)}
                                            >
                                                {i + 1}
                                            </Button>
                                        </li>
                                    ))}
                                    <li>
                                        <Button
                                            variant="outline-secondary"
                                            className="rounded-pill px-3 py-1"
                                            disabled={currentPage === totalPages}
                                            onClick={() => goToPage(currentPage + 1)}
                                        >
                                            &raquo;
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </Container>
                </section>

                <TestimonialSection />
            </main>
            <Footer />
        </div>
    );
};

export default Product;
